import { render } from "./EpisodeGallery.vue?vue&type=template&id=4f08e56a&scoped=true"
import script from "./EpisodeGallery.vue?vue&type=script&lang=js"
export * from "./EpisodeGallery.vue?vue&type=script&lang=js"

import "./EpisodeGallery.vue?vue&type=style&index=0&id=4f08e56a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f08e56a"]])

export default __exports__